// Where to send a user right after login (and when /login is opened while
// already logged in). The backend lets a tenant whose licence is suspended or
// cancelled log in, but marks the user with `license_blocked` and only lets
// that token reach billing/auth endpoints (server.LICENSE_LAPSED_ALLOWED_PREFIXES).
// Sending such a user to /dashboard would fire a burst of 403s, so:
//   - admins go straight to the checkout page to renew,
//   - everyone else sees a "contact your administrator" notice, since only a
//     company admin may pay (POST /api/billing/checkout/initiate is admin-only).
// The superuser is the platform operator (no company, no licence, never
// flagged): it always lands on the platform panel.
import { homePathFor, isAdmin, isSuperuser } from './permissions';

export const LICENSE_INACTIVE_PATH = '/license-inactive';

// Licence states that the LicenseGuard treats as blocking.
export const LICENSE_BLOCKING_STATUSES = ['trial_expired', 'past_due', 'suspended', 'cancelled'];

export const postLoginPath = (user) => {
  if (isSuperuser(user) || !user?.license_blocked) return homePathFor(user);
  return isAdmin(user) ? '/checkout' : LICENSE_INACTIVE_PATH;
};

const readStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch {
    return null;
  }
};

export const storedUserLicenseBlocked = () => !!readStoredUser()?.license_blocked;

// Drop a stale `license_blocked` flag once the licence is active again
// (the flag is only refreshed on login).
export const clearStoredLicenseBlocked = () => {
  const u = readStoredUser();
  if (!u?.license_blocked) return;
  try {
    localStorage.setItem('user', JSON.stringify({ ...u, license_blocked: false }));
  } catch { /* storage unavailable: harmless, flag is refreshed on next login */ }
};
